import styled, { css } from 'styled-components';

// import mixin from '../../_foundations/Mixin';
import HorizontalFlow from '../HorizontalFlow';

const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 1rem;
  ${(props) =>
    props.children.length > 1 &&
    css`
      & > ${HorizontalFlow}:last-child {
        justify-content: end;
      }
    `}

  ${(props) =>
    props.children.length === 3 &&
    css`
      grid-template-columns: 1fr auto 1fr;
      & > ${HorizontalFlow}:first-child + ${HorizontalFlow} {
        justify-content: center;
      }
    `}
`;

export default Header;
